import ReactDOM from "react-dom/client";
import { getEnv } from "./util/tenant-env";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Missing #root element");
}

const resolvedEnv = getEnv();
if (!resolvedEnv) {
  rootEl.innerHTML = `
    <div style="font-family: system-ui, sans-serif; max-width: 40rem; margin: 4rem auto; padding: 0 1rem; color: #1a1a1a;">
      <h1 style="font-size: 1.5rem; margin-bottom: 0.75rem;">Host not configured</h1>
      <p style="line-height: 1.5; margin: 0;">
        This hostname is not mapped to a BtoolsB tenant or central environment.
        Check <code>frontend/src/env.ts</code> on the server and rebuild the frontend image.
      </p>
    </div>
  `;
} else {
  import("./App").then(({ default: App }) => {
    const root = ReactDOM.createRoot(rootEl);
    root.render(<App />);
  });
}
